import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';

import { throwIfAlreadyLoaded } from '../shared/helpers/module-import-check';
import { StandardLayoutComponent } from '../layout/standard-layout/standard-layout.component';
import { SharedModule } from '../shared/shared.module';
import { P404Component } from './p404/p404.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { FullPageLayoutComponent } from './full-page-layout/full-page-layout.component';

@NgModule({
  imports: [SharedModule, RouterModule],
  declarations: [
    StandardLayoutComponent,
    FullPageLayoutComponent,
    P404Component,
    HomeComponent,
    HeaderComponent,
  ],
  exports: [StandardLayoutComponent, FullPageLayoutComponent, P404Component, HomeComponent]
})
export class LayoutModule {
  constructor(
    @Optional()
    @SkipSelf()
    currentModule: LayoutModule
  ) {
    throwIfAlreadyLoaded(currentModule, 'LayoutModule');
  }
}
